function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _excluded = ["name", "path", "meta"],
    _excluded2 = ["name"];
var LanguageRouterState = {};
var LanguageRouter = {
  name: 'LangRouter',
  render: function render(h) {
    return h('router-view');
  }
};

var langMetaFactory = function langMetaFactory(lang, isRoot) {
  return function (_ref) {
    var name = _ref.name,
        inputPath = _ref.path,
        _ref$meta = _ref.meta,
        meta = _ref$meta === void 0 ? {} : _ref$meta,
        route = _objectWithoutProperties(_ref, _excluded);

    return _objectSpread2(_objectSpread2({}, route), {}, {
      path: typeof inputPath === 'string' ? inputPath : inputPath[lang],
      name: isRoot ? name : "".concat(name, ":").concat(lang),
      meta: _objectSpread2(_objectSpread2({}, meta), {}, {
        lang: lang
      })
    });
  };
};

var langRoutesFactory = function langRoutesFactory(routes, isRoot) {
  return function (langCode) {
    return {
      path: isRoot ? '/' : "/".concat(langCode),
      component: LanguageRouter,
      children: routes.map(langMetaFactory(langCode, isRoot))
    };
  };
};

var index = {
  vuexGetters: {
    currentLang: function currentLang(_ref2) {
      var route = _ref2.route;
      var _route$meta = route.meta,
          meta = _route$meta === void 0 ? {} : _route$meta;
      return meta.lang || '';
    }
  },
  createRoutes: function createRoutes(defaultLangCode) {
    for (var _len = arguments.length, langCodes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      langCodes[_key - 1] = arguments[_key];
    }

    return function () {
      LanguageRouterState.defaultLang = defaultLangCode;
      LanguageRouterState.list = [defaultLangCode].concat(langCodes);

      for (var _len2 = arguments.length, routes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        routes[_key2] = arguments[_key2];
      }

      LanguageRouterState.routes = [].concat(_toConsumableArray(langCodes.map(langRoutesFactory(routes))), [langRoutesFactory(routes, true)(defaultLangCode)]);
      return LanguageRouterState.routes;
    };
  },
  install: function install(Vue) {
    var _LanguageRouterState = LanguageRouterState,
        _LanguageRouterState$ = _LanguageRouterState.defaultLang,
        defaultLang = _LanguageRouterState$ === void 0 ? null : _LanguageRouterState$,
        _LanguageRouterState$2 = _LanguageRouterState.list,
        list = _LanguageRouterState$2 === void 0 ? [] : _LanguageRouterState$2;
    LanguageRouterState = new Vue({
      name: 'LangRouterVM',
      data: function data() {
        return {
          defaultLang: defaultLang,
          list: list
        };
      }
    });

    var getLangRouteName = function getLangRouteName(context, routeName, lang) {
      var langCode = lang || context.$lang.current;
      var langCodeSuffix = langCode === LanguageRouterState.defaultLang ? '' : ":".concat(langCode);
      return "".concat(routeName.replace(/:.+$/, '')).concat(langCodeSuffix);
    };

    Vue.component('LangRouterLink', {
      name: 'LangRouterLink',
      props: {
        to: {
          type: Object,
          required: true
        },
        exact: {
          type: Boolean,
          default: false
        }
      },
      render: function render(h) {
        var props = {
          to: this.$lang.route(this.to),
          exact: this.exact
        };
        return h('RouterLink', {
          props: props
        }, this.$slots.default);
      }
    });
    Vue.component('LangSwitchLink', {
      name: 'LangSwitchLink',
      props: {
        lang: {
          type: String,
          required: true
        },
        params: {
          type: Object,
          default: null
        }
      },
      render: function render(h) {
        var props = {
          to: {
            params: this.params || this.$route.params,
            query: this.$route.query,
            name: getLangRouteName(this, this.$route.name, this.lang)
          }
        };
        return h('RouterLink', {
          props: props
        }, this.$slots.default);
      }
    });
    Vue.mixin({
      computed: {
        $lang: function $lang() {
          var _this = this;

          return {
            list: LanguageRouterState.list,
            default: LanguageRouterState.defaultLang,
            routes: LanguageRouterState.routes,
            current: this.$store && this.$store.getters.currentLang,
            route: function route(_ref3) {
              var name = _ref3.name,
                  _route = _objectWithoutProperties(_ref3, _excluded2);

              return _objectSpread2(_objectSpread2({}, _route), {}, {
                name: getLangRouteName(_this, name)
              });
            },
            switch: function _switch(toLang) {
              return _objectSpread2(_objectSpread2({}, _this.$route), {}, {
                name: getLangRouteName(_this, _this.$route.name, toLang)
              });
            }
          };
        }
      }
    });
  }
};

export { index as default };
